import _ from "lodash";
import React, {Component} from "react";
import Key from '../Keyboard/Key';

class Keyboard extends Component {
    pressKey = (key) => {
        this.props.onPressKey(key);
    }

    share = () => {
        const data = this.getShareData();
        if (navigator && navigator.share && navigator.canShare(data)) {
            navigator.share(data).then(() => {
                window.dataLayer.push({'event': 'share'});
            }).catch((error) => {
                alert('Sharing failed.')
            });
        } else {
            alert('Your browser does not support sharing, this could be because you are viewing this through facebook messenger, please consider opening in chrome when you play.');
        }
    }

    getShareData = () => {
        let scoreEmojis = '';
        _.forEach(this.props.attempts, (attempt) => {
            if (attempt[0] === '')
                return false;
            _.forEach(attempt, (letter, index) => {
                if (letter === this.props.word[index]) {
                    scoreEmojis += '🟩';
                } else if (this.props.word.indexOf(letter) !== -1) {
                    scoreEmojis += '🟧'
                } else {
                    scoreEmojis += '⬛'
                }
            });
            scoreEmojis += '\n';
        });

        return {
            title: 'My GUMMIDGE score',
            text: 'I found this word in ' + this.props.attempt + ' attempt(s)! \n \n' + scoreEmojis + '\nTry beat my score!',
            url: 'https://gummidge.netlify.app/?word=' + this.props.wordID 
        };
    }
    
    render() {
        const {attempt, attempts, word, complete, success} = this.props;
        return (
            complete ?
                success ? 
                <div class="success">
                    <h2>+{7 - attempt} POINTS!</h2>
                    <p>You found the word in {attempt} attempt{attempt > 1 ? `(s)` : <></>}, well done.</p>
                    <div class="complete-buttons">
                        <button class="complete-button" onClick={() => {window.location = window.location.href.split("?")[0];}}>
                            NEXT WORD <i class="fas fa-angle-double-right"></i>
                        </button>

                        <button class="share-button" onClick={this.share}>
                            <i class="fas fa-share-square"></i> SHARE
                            <span>(Share to compete)</span>
                        </button>
                    </div>
                </div>
                : 
                <div class="failure">
                    <h2>OH NO!</h2>
                    <p>Unfortunately you didn't find the word ({word}).</p>
                    <div class="complete-buttons">
                        <button class="complete-button" onClick={() => {window.location = window.location.href.split("?")[0];}}>
                            NEXT WORD <i class="fas fa-angle-double-right"></i>
                        </button>
                    </div>
                </div>
            :
            <div class="keyboard">
                <div class="keyboard__row keyboard__row--top">
                    <Key text="Q" onClick={this.pressKey} attempts={attempts} word={word} attempt={attempt}/>
                    <Key text="W" onClick={this.pressKey} attempts={attempts} word={word} attempt={attempt}/>
                    <Key text="E" onClick={this.pressKey} attempts={attempts} word={word} attempt={attempt}/>
                    <Key text="R" onClick={this.pressKey} attempts={attempts} word={word} attempt={attempt}/>
                    <Key text="T" onClick={this.pressKey} attempts={attempts} word={word} attempt={attempt}/>
                    <Key text="Y" onClick={this.pressKey} attempts={attempts} word={word} attempt={attempt}/>
                    <Key text="U" onClick={this.pressKey} attempts={attempts} word={word} attempt={attempt}/>
                    <Key text="I" onClick={this.pressKey} attempts={attempts} word={word} attempt={attempt}/>
                    <Key text="O" onClick={this.pressKey} attempts={attempts} word={word} attempt={attempt}/>
                    <Key text="P" onClick={this.pressKey} attempts={attempts} word={word} attempt={attempt}/>
                </div>
                <div class="keyboard__row keyboard__row--middle">
                    <Key text="A" onClick={this.pressKey} attempts={attempts} word={word} attempt={attempt}/>
                    <Key text="S" onClick={this.pressKey} attempts={attempts} word={word} attempt={attempt}/>
                    <Key text="D" onClick={this.pressKey} attempts={attempts} word={word} attempt={attempt}/>
                    <Key text="F" onClick={this.pressKey} attempts={attempts} word={word} attempt={attempt}/>
                    <Key text="G" onClick={this.pressKey} attempts={attempts} word={word} attempt={attempt}/>
                    <Key text="H" onClick={this.pressKey} attempts={attempts} word={word} attempt={attempt}/>
                    <Key text="J" onClick={this.pressKey} attempts={attempts} word={word} attempt={attempt}/>
                    <Key text="K" onClick={this.pressKey} attempts={attempts} word={word} attempt={attempt}/>
                    <Key text="L" onClick={this.pressKey} attempts={attempts} word={word} attempt={attempt}/>
                </div>
                <div class="keyboard__row keyboard__row--bottom">
                    <Key text="ENTER" onClick={this.pressKey} attempts={attempts} word={word} attempt={attempt}/>
                    <Key text="Z" onClick={this.pressKey} attempts={attempts} word={word} attempt={attempt}/>
                    <Key text="X" onClick={this.pressKey} attempts={attempts} word={word} attempt={attempt}/>
                    <Key text="C" onClick={this.pressKey} attempts={attempts} word={word} attempt={attempt}/>
                    <Key text="V" onClick={this.pressKey} attempts={attempts} word={word} attempt={attempt}/>
                    <Key text="B" onClick={this.pressKey} attempts={attempts} word={word} attempt={attempt}/>
                    <Key text="N" onClick={this.pressKey} attempts={attempts} word={word} attempt={attempt}/>
                    <Key text="M" onClick={this.pressKey} attempts={attempts} word={word} attempt={attempt}/>
                    <Key text="DEL" onClick={this.pressKey} attempts={attempts} word={word} attempt={attempt}/>
                </div>
            </div>
        );
    }
}

export default Keyboard;